(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bought-together"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bought-together')) {
    class BoughtTogether extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-fbt-item]')].map((el) => ({
          el,
          current: el.hasAttribute('data-fbt-current'),
          ...JSON.parse(el.querySelector('[data-fbt-variants]').textContent),
          variant: null,
        }));
        this.button = this.querySelector('[data-fbt-add]');
        this.label = this.querySelector('[data-fbt-label]');
        this.errorEl = this.querySelector('[data-fbt-error]');

        this.items.forEach((item) => {
          item.variant = item.variants.find((v) => v.selected) || item.variants[0];
          item.el.querySelectorAll('[data-fbt-option]').forEach((select) => {
            select.addEventListener('change', () => {
              this.resolve(item);
              if (item.current) this.followCurrent();
            });
          });
          const toggle = item.el.querySelector('[data-fbt-toggle]');
          if (toggle) {
            toggle.addEventListener('change', () => {
              item.el.dataset.fbtSelected = String(toggle.checked);
              this.update();
            });
          }
        });

        this.button.addEventListener('click', () => this.add());

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            // From main-product's own picker, or — when this renders as its own
            // section further down the page — any picker showing this product.
            const variant = event.data.variant;
            const ours = variant && this.currentItem.variants.some((v) => v.id === variant.id);
            if (event.data.sectionId !== this.dataset.sectionId && !ours) return;
            this.setCurrent(variant);
          });
        }

        this.resolve(this.currentItem);
        this.followCurrent();
        this.update();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      get currentItem() {
        return this.items.find((item) => item.current);
      }

      setCurrent(variant) {
        const item = this.currentItem;
        const match = variant ? item.variants.find((v) => v.id === variant.id) : null;
        if (match) {
          item.el.querySelectorAll('[data-fbt-option]').forEach((select) => {
            select.value = match.options[Number(select.dataset.fbtOption)];
          });
          item.variant = match;
          this.resolve(item);
        } else {
          item.variant = null;
          this.update();
        }
        this.followCurrent();
      }

      // An add-on option named like one of the current product's ("Størrelse")
      // takes the main picker's value when it has it.
      followCurrent() {
        const current = this.currentItem;
        if (!current.variant) return;
        const values = new Map(current.variant.options.map((value, i) => [current.names[i], value]));
        this.items.forEach((item) => {
          if (item.current) return;
          const followed = new Map();
          // Second chance by value: a combined option like Ella Barn's
          // "3kg / 100x140cm" still names the cover's "100x140 cm".
          const squash = (value) => value.toLowerCase().replace(/\s+/g, '');
          const currentValues = current.variant.options.map(squash);
          item.el.querySelectorAll('[data-fbt-option]').forEach((select) => {
            let wanted = values.get(select.dataset.fbtOptionName);
            if (!wanted || ![...select.options].some((o) => o.value === wanted)) {
              const hit = [...select.options].find((o) => currentValues.some((v) => v.includes(squash(o.value))));
              wanted = hit ? hit.value : null;
            }
            if (wanted) {
              select.value = wanted;
              followed.set(Number(select.dataset.fbtOption), wanted);
            }
          });
          this.resolve(item, followed.size ? followed : null);
        });
      }

      // `followed` holds the option values the main picker set. If that combo
      // is sold out (140x220 in Navy), keep those values and take the first
      // in-stock variant that has them, rather than offering a dead line.
      resolve(item, followed) {
        const selects = [...item.el.querySelectorAll('[data-fbt-option]')];
        const chosen = item.variant ? [...item.variant.options] : [];
        selects.forEach((select) => {
          chosen[Number(select.dataset.fbtOption)] = select.value;
        });
        const matches = (v, wanted) => v.options.every((value, i) => wanted[i] === undefined || value === wanted[i]);
        item.variant = item.variants.find((v) => matches(v, chosen)) || null;

        if (followed && !(item.variant && item.variant.available)) {
          const fixed = [];
          followed.forEach((value, i) => (fixed[i] = value));
          const fallback = item.variants.find((v) => v.available && matches(v, fixed));
          if (fallback) {
            item.variant = fallback;
            selects.forEach((select) => (select.value = fallback.options[Number(select.dataset.fbtOption)]));
          }
        }

        // Grey out values that are sold out with the other options as chosen.
        selects.forEach((select) => {
          const index = Number(select.dataset.fbtOption);
          [...select.options].forEach((option) => {
            const wanted = item.variant ? [...item.variant.options] : [...chosen];
            wanted[index] = option.value;
            option.disabled = !item.variants.some((v) => v.available && matches(v, wanted));
          });
        });

        if (item.variant) this.paint(item);
        this.update();
      }

      paint(item) {
        const v = item.variant;
        item.el.querySelector('[data-fbt-price]').textContent = v.price_money;
        const compare = item.el.querySelector('[data-fbt-compare]');
        compare.hidden = !(v.compare_at_price > v.price);
        compare.textContent = v.compare_money;
        const img = item.el.querySelector('[data-fbt-image]');
        if (img && v.image) {
          img.src = v.image;
          img.removeAttribute('srcset');
        }
      }

      get selected() {
        return this.items.filter((item) => item.current || item.el.dataset.fbtSelected !== 'false');
      }

      update() {
        const selected = this.selected;
        const buyable = selected.every((item) => item.variant && item.variant.available);
        const total = selected.reduce((sum, item) => sum + (item.variant ? item.variant.price : 0), 0);
        const compare = selected.reduce(
          (sum, item) => sum + (item.variant ? Math.max(item.variant.compare_at_price || 0, item.variant.price) : 0),
          0
        );

        this.querySelector('[data-fbt-total]').textContent = this.money(total);
        const compareEl = this.querySelector('[data-fbt-compare-total]');
        compareEl.hidden = !(compare > total);
        compareEl.textContent = this.money(compare);

        const count = selected.length;
        let label = this.dataset.labelOne;
        if (count === 2) label = this.dataset.labelTwo;
        if (count > 2) label = this.dataset.labelMany.replace('__count__', count);
        this.label.textContent = buyable ? label : this.dataset.labelUnavailable;
        this.button.disabled = !buyable;
      }

      // shop.money_format, e.g. "{{amount_no_decimals_with_comma_separator}} kr".
      money(cents) {
        const format = this.dataset.moneyFormat;
        const group = (value, thousands, decimal, decimals) => {
          const [whole, fraction] = (value / 100).toFixed(decimals).split('.');
          const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return fraction ? grouped + decimal + fraction : grouped;
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
          switch (key) {
            case 'amount_no_decimals':
              return group(cents, ',', '.', 0);
            case 'amount_with_comma_separator':
              return group(cents, '.', ',', 2);
            case 'amount_no_decimals_with_comma_separator':
              return group(cents, '.', ',', 0);
            case 'amount_with_apostrophe_separator':
              return group(cents, "'", '.', 2);
            case 'amount_with_space_separator':
              return group(cents, ' ', ',', 2);
            case 'amount_no_decimals_with_space_separator':
              return group(cents, ' ', ',', 0);
            default:
              return group(cents, ',', '.', 2);
          }
        });
      }

      async add() {
        if (this.button.getAttribute('aria-busy') === 'true') return;
        this.button.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        this.errorEl.hidden = true;
        const drawer = document.querySelector('cart-drawer');

        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: this.selected.map((item) => ({ id: item.variant.id, quantity: 1 })),
              sections: drawer ? drawer.getSectionsToRender().map((section) => section.id) : [],
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || '');

          if (!drawer) {
            window.location = window.routes.cart_url;
            return;
          }
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bought-together', cartData: data });
          }
          drawer.classList.remove('is-empty');
          drawer.setActiveElement(this.button);
          drawer.renderContents(data);
        } catch (error) {
          this.errorEl.textContent = error.message || this.dataset.error;
          this.errorEl.hidden = false;
        } finally {
          this.button.removeAttribute('aria-busy');
          this.update();
        }
      }
    }

    customElements.define('bought-together', BoughtTogether);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-swatches"] && !Shopify.designMode) return;
  try {
    /* One delegated listener for every card on the page, so cards that arrive
     later — a section re-render, a slider, pagination — need no wiring. */
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;

    const root = swatch.closest('[data-card-swatch-root]');
    if (!root) return;

    event.preventDefault();

    root.querySelectorAll('[data-card-swatch]').forEach((other) => {
      other.setAttribute('aria-pressed', other === swatch ? 'true' : 'false');
    });

    const image = root.querySelector('[data-card-swatch-image]');
    const { src, srcset, width, height, alt, url } = swatch.dataset;

    if (image && src) {
      image.srcset = srcset || '';
      image.src = src;
      if (width) image.width = Number(width);
      if (height) image.height = Number(height);
      if (alt) image.alt = alt;

      // Dawn's card fades a second image in on hover. Once a colour is picked
      // that would show a different colour's photo, so it is retired —
      // removed, not hidden: Dawn fades the FIRST image out on hover while it
      // is `:not(:only-child)`, and a hidden sibling still counts.
      image.parentElement
        ?.querySelectorAll('img:not([data-card-swatch-image])')
        .forEach((secondary) => secondary.remove());
    }

    if (url) {
      root.querySelectorAll('[data-card-swatch-link]').forEach((link) => {
        link.href = url;
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-campaign-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('campaign-banner')) {
    customElements.define('campaign-banner', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => this.onClick(event));
        // `?kampagne-preview` in the URL shows a box before its start, so a
        // campaign can be checked on the real page ahead of launch. Any other
        // box in the same block stack is hidden meanwhile, so the preview
        // reads as what the page will look like.
        const preview = /[?&]kampagne-preview\b/.test(location.search);
        const start = Number(this.dataset.start) * 1000;
        if (preview) {
          const future = start && start > Date.now();
          if (future) {
            this.hidden = false;
            document.querySelectorAll('campaign-banner').forEach((other) => {
              if (other !== this && !(Number(other.dataset.start) * 1000 > Date.now())) other.hidden = true;
            });
          }
        } else if (start) {
          const wait = start - Date.now();
          this.hidden = wait > 0;
          if (wait > 0 && wait < 2147483647) {
            this.startTimer = setTimeout(() => { this.hidden = false; }, wait + 500);
          }
        }
        const end = Number(this.dataset.end) * 1000;
        if (!end) return;
        const pad = (n) => String(n).padStart(2, '0');
        const parts = ['d', 'h', 'm', 's'].map((k) => this.querySelector(`[data-${k}]`));
        const tick = () => {
          const left = Math.floor((end - Date.now()) / 1000);
          if (left <= 0) {
            clearInterval(this.timer);
            this.hidden = true;
            return;
          }
          const values = [
            Math.floor(left / 86400),
            Math.floor((left % 86400) / 3600),
            Math.floor((left % 3600) / 60),
            left % 60,
          ];
          parts.forEach((el, i) => { if (el) el.textContent = pad(values[i]); });
        };
        tick();
        this.timer = setInterval(tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.startTimer);
      }

      onClick(event) {
        const btn = event.target.closest('.anew-campaign-banner__copy');
        if (!btn) return;
        const label = btn.textContent;
        const done = () => {
          btn.textContent = btn.dataset.copied;
          setTimeout(() => { btn.textContent = label; }, 2000);
        };
        const fallback = () => {
          const t = document.createElement('textarea');
          t.value = btn.dataset.code;
          t.setAttribute('readonly', '');
          t.style.position = 'fixed';
          t.style.opacity = '0';
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          t.remove();
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(btn.dataset.code).then(done, fallback);
        } else {
          fallback();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-gift-card-amount"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-card-amount')) {
    customElements.define(
      'gift-card-amount',
      class GiftCardAmount extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-gift-amount-variants]').textContent);
          this.panel = this.querySelector('.anew-gift-amount__panel');
          this.input = this.querySelector('[data-gift-amount-input]');
          this.note = this.querySelector('[data-gift-amount-note]');
          this.hintText = this.querySelector('[data-gift-amount-hint]')?.textContent;
          this.emptyText = this.querySelector('[data-gift-amount-empty]')?.textContent;

          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-gift-amount-fixed]')) {
              this.togglePanel(false);
              this.select(this.find(event.target.value));
            } else if (event.target.matches('[data-gift-amount-custom]')) {
              this.togglePanel(true);
              this.input.focus();
              this.applyTyped(false);
            }
          });
          this.input?.addEventListener('input', () => this.applyTyped(false));
          this.input?.addEventListener('blur', () => this.applyTyped(true));
        }

        find(id) {
          return this.variants.find((v) => String(v.id) === String(id));
        }

        togglePanel(open) {
          if (!this.panel) return;
          this.panel.hidden = !open;
          if (!open) this.setSubmitBlocked(false);
        }

        // "1.250", "1250 kr" and "1250,00" all read as 1250.
        typedCents() {
          const raw = (this.input.value || '').replace(/[.\s]/g, '').split(',')[0].replace(/\D/g, '');
          return raw ? parseInt(raw, 10) * 100 : null;
        }

        nearest(cents) {
          return this.variants.reduce((best, v) =>
            Math.abs(v.cents - cents) <= Math.abs(best.cents - cents) ? v : best
          );
        }

        applyTyped(commit) {
          const cents = this.typedCents();
          if (cents === null) {
            this.note.textContent = commit && this.input.value === '' ? this.emptyText : this.hintText;
            this.setSubmitBlocked(true);
            return;
          }
          const match = this.nearest(cents);
          this.select(match);
          this.setSubmitBlocked(false);
          this.note.textContent =
            match.cents === cents ? this.hintText : this.dataset.rounded.replace('[amount]', match.label);
          if (commit) this.input.value = String(match.cents / 100);
        }

        // An open, empty field must not add whatever amount was picked before.
        setSubmitBlocked(blocked) {
          const button = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
          if (button) button.disabled = blocked;
        }

        select(variant) {
          if (!variant) return;
          const form = document.getElementById(this.dataset.formId);
          const idInput = form?.querySelector('input[name="id"]');
          if (idInput) idInput.value = variant.id;

          const price = document.querySelector(`#price-${this.dataset.sectionId} .anew-pdp__price-now`);
          if (price) price.textContent = variant.price;

          const recipient = form?.querySelector('recipient-form');
          if (recipient) recipient.currentProductVariantId = String(variant.id);

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-price-guarantee"] && !Shopify.designMode) return;
  try {
    (() => {
    // pointerdown rather than click, so a tap that starts a swipe or a scroll
    // closes the box too — a touch scroll never fires click.
    const closeOutside = (target) => {
      document.querySelectorAll('details.anew-price-guarantee[open]').forEach((el) => {
        if (!target || !el.contains(target)) el.removeAttribute('open');
      });
    };
    document.addEventListener('pointerdown', (event) => closeOutside(event.target));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeOutside(null);
    });

    // The campaign pill swaps in and out at its boundaries in the browser too,
    // so a page left open (or served from cache) across one is still right.
    const syncCampaign = () => {
      // `?kampagne-preview` jumps to the start of the next campaign window.
      const preview = /[?&]kampagne-preview\b/.test(location.search);
      let now = Date.now() / 1000;
      if (preview) {
        document.querySelectorAll('[data-pg-campaign][data-start]').forEach((pill) => {
          const start = Number(pill.dataset.start);
          if (start > now) now = start;
        });
      }
      let next = Infinity;
      document.querySelectorAll('[data-pg-campaign]').forEach((pill) => {
        const start = Number(pill.dataset.start) || 0;
        const end = Number(pill.dataset.end) || Infinity;
        const live = now >= start && now < end;
        pill.hidden = !live;
        const regular = pill.parentElement && pill.parentElement.querySelector('[data-pg-regular]');
        if (regular) regular.hidden = live;
        [start, end].forEach((t) => { if (t > now && t < next) next = t; });
      });
      if (!preview && next !== Infinity) setTimeout(syncCampaign, Math.min((next - now) * 1000 + 500, 2147483647));
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncCampaign);
    } else {
      syncCampaign();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["review-quote-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const isCut = (body) => body.scrollHeight - body.clientHeight > 1;

    // Shows the button only where the clamp actually cut text. Re-measured on
    // resize, since a quote that fits at desktop width is cut on a phone.
    const sync = () => {
      document.querySelectorAll('[data-review-quote-body]').forEach((body) => {
        if (body.classList.contains('is-expanded')) return;
        const button = body.parentElement.querySelector('[data-review-quote-more]');
        if (button) button.hidden = !isCut(body);
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-review-quote-more]');
      if (!button) return;
      const body = document.getElementById(button.getAttribute('aria-controls'));
      if (!body) return;
      const open = !body.classList.contains('is-expanded');
      body.classList.toggle('is-expanded', open);
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? button.dataset.labelLess : button.dataset.labelMore;
    });

    let frame;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(sync);
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
    // Section re-renders in the Theme Editor bring in new cards.
    document.addEventListener('shopify:section:load', sync);
    window.addEventListener('load', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
